import { hotTopics } from "@/mocks/guaData";

const heroStats = [
  { num: "12.6万+", label: "精选神回复" },
  { num: "3.8万+", label: "评论名场面" },
  { num: "6个", label: "专属频道" },
  { num: "每日", label: "滚动更新" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* 背景图 + 遮罩 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=playful%20vector%20illustration%20of%20a%20big%20watermelon%20patch%20with%20chat%20bubbles%20and%20laughing%20faces%2C%20fresh%20mint%20green%20and%20soft%20cream%20background%2C%20scattered%20confetti%20and%20stars%2C%20warm%20flat%20cartoon%20style%2C%20clean%20light%20and%20cheerful%2C%20no%20text&width=1600&height=900&seq=hero-melon-01&orientation=landscape"
          alt="呱呱吃瓜评论区名场面背景插画"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary-900/80 via-primary-800/70 to-accent-700/60"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-10 pt-28 md:px-6 md:pb-14 md:pt-40">
        {/* 徽章 */}
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-flashlight-line text-secondary-300"></i>
          评论区才是瓜的精华 · 每日精选
        </span>

        {/* 主标题 */}
        <h1 className="mt-6 text-center font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          吃瓜一时爽，<br className="md:hidden" />
          <span className="text-secondary-300">评论区</span>才是精华
        </h1>
        <p className="mt-5 max-w-2xl text-center text-base text-background-100 md:text-lg">
          呱呱吃瓜把你要的呱呱吃瓜评论区、神回复、网友神评与热评精选都汇聚起来。弹幕梗、名场面不用自己翻，看热闹就看这层楼。
        </p>

        {/* CTA */}
        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#reply"
            className="whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-transform hover:-translate-y-0.5 hover:bg-accent-400"
          >
            去逛吃瓜神回复
          </a>
          <a
            href="#hot"
            className="whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            看今日热瓜榜
          </a>
        </div>

        {/* 数据 */}
        <dl className="mt-10 grid w-full max-w-2xl grid-cols-2 gap-3 sm:grid-cols-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-50/20 bg-background-50/10 px-4 py-3 text-center backdrop-blur"
            >
              <dd className="font-heading text-2xl text-secondary-200">{s.num}</dd>
              <dt className="mt-1 text-xs text-background-100">{s.label}</dt>
            </div>
          ))}
        </dl>
      </div>

      {/* 滚动热瓜 Ticker */}
      <div className="relative border-t border-background-50/15 bg-background-950/30 py-3 backdrop-blur">
        <div className="ticker-mask overflow-hidden">
          <div className="flex w-max animate-[ticker_40s_linear_infinite] gap-10 px-6">
            {[...hotTopics, ...hotTopics].map((t, i) => (
              <a
                key={i}
                href="#hot"
                className="flex items-center gap-2 whitespace-nowrap text-sm text-background-100"
              >
                <i className="ri-fire-line text-accent-300"></i>
                <span className="font-medium text-background-50">{t.title}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}